// src/LoginPage.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthProvider';
import api from './api/http';
import './LoginPage.css';

// Hjälpare: mappa olika backend-fältnamn till frontend-formatet
function normalizeCompany(c) {
  if (!c) return null;
  return {
    id: c.id,
    companyName: c.companyName ?? c.company_name ?? c.name ?? null,
    profilePic: c.profilePic ?? c.profile_pic ?? null,
    role: (c.role || '').toLowerCase(),
  };
}

export default function LoginPage() {
  const navigate = useNavigate();
  const { setCurrentCompany } = useContext(AuthContext);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setErr('');

    const emailNorm = String(email || '').trim().toLowerCase();
    const pwd = String(password || '');

    if (!emailNorm || !pwd) {
      setErr('Ange både e-post och lösenord.');
      return;
    }

    setLoading(true);
    try {
      // 1) Logga in (servern sätter cookie)
      const r = await api.post('/api/login', { email: emailNorm, password: pwd });
      if (!r?.data?.ok) throw new Error(r?.data?.error || 'Fel e-post eller lösenord.');

      // 2) Hämta company direkt ur login-svaret
      const company = normalizeCompany(r.data.company);
      if (!company || !company.id) {
        throw new Error('Inloggad men saknar företagsdata.');
      }

      // 3) Cache:a och uppdatera context
      try {
        localStorage.setItem('currentCompany', JSON.stringify(company));
      } catch {}
      setCurrentCompany(company);

      // 4) Navigera bestämt till dashboard
      navigate('/dashboard', { replace: true });
      setTimeout(() => {
        if (!window.location.pathname.startsWith('/dashboard')) {
          window.location.assign('/dashboard');
        }
      }, 150);
    } catch (e2) {
      const msg =
        e2?.response?.data?.error ||
        (e2?.response?.status === 401 ? 'Fel e-post eller lösenord.' : null) ||
        e2?.message ||
        'Kunde inte ansluta till servern.';
      setErr(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-container">
      <h2 className="login-title">Logga in</h2>

      <form onSubmit={handleSubmit} className="login-form" noValidate>
        <div className="form-group">
          <label htmlFor="email">E-post</label>
          <input
            type="email"
            id="email"
            placeholder="ange din e-post"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Lösenord</label>
          <input
            type="password"
            id="password"
            placeholder="ange ditt lösenord"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        {err && <p className="error-text">{err}</p>}

        <button type="submit" className="btn-primary" disabled={loading}>
          {loading ? 'Loggar in…' : 'Logga in'}
        </button>
      </form>

      <button
        type="button"
        onClick={() => navigate('/forgot-password')}
        style={{
          marginTop: '12px',
          background: 'none',
          border: 'none',
          color: '#217a43',
          fontSize: '1rem',
          cursor: 'pointer',
          textDecoration: 'underline',
        }}
      >
        Glömt lösenord?
      </button>

      <button
        type="button"
        onClick={() => navigate('/')}
        style={{
          marginTop: '10px',
          background: 'none',
          border: 'none',
          color: '#217a43',
          fontSize: '1.1rem',
          cursor: 'pointer',
          textDecoration: 'underline',
        }}
      >
        ← Till startsidan
      </button>
    </div>
  );
}
